import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "top",
  "use": "top-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"top\"><defs><style></style></defs><path d=\"M523.101 324.686l368.213 368.212c6.248 6.248 6.248 16.38 0 22.628-6.248 6.248-16.379 6.248-22.628 0L511.783 358.623 154.882 715.525c-6.249 6.248-16.38 6.248-22.628 0-6.249-6.248-6.248-16.379 0-22.627l368.211-368.212A15.95 15.95 0 01511.783 320a15.95 15.95 0 0111.318 4.686z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol